import *as _ from 'lodash'
import {GLTransactionBO} from "./GLTransactionBO";
import {MessageType} from "../PA.Core/PA.Core.IF.Basic";
import {esWB_GLTransaction} from "../PA.Core/PAdbSchema";

export class GLTransactionBOValidations {

    static ValidateEmptyFields(aBO: GLTransactionBO): Promise<void> {

        return (async () => {
            try {
                // Validate Transaction
                if (_.isEmpty(aBO.WB_GLTransaction.cif.TXN_ID) || _.isNull(aBO.WB_GLTransaction.cif.TXN_ID)) {
                    aBO.ValidateMessageProvider.addMessage(
                        {
                            type: MessageType.Error,
                            code: 'transactionid',
                            title: "Transaction ID cannot be empty",
                            description: "",
                            subtitle: "",
                            count: 0
                        })
                } else {
                    aBO.ValidateMessageProvider.removeMessage('transactionid')
                }

                if (_.isEmpty(aBO.WB_GLTransaction.cif.TXN_NAME)) {
                    aBO.ValidateMessageProvider.addMessage(
                        {
                            type: MessageType.Error,
                            code: 'transactionname',
                            title: "Transaction Name cannot be empty",
                            description: "",
                            subtitle: "",
                            count: 0
                        })
                } else {
                    aBO.ValidateMessageProvider.removeMessage('transactionname')
                }

                if (_.isEmpty(aBO.WB_GLTransaction.cif.SOURCE_ID) || _.isNull(aBO.WB_GLTransaction.cif.SOURCE_ID)) {
                    aBO.ValidateMessageProvider.addMessage(
                        {
                            type: MessageType.Error,
                            code: 'sourceid',
                            title: "Source ID cannot be empty",
                            description: "",
                            subtitle: "",
                            count: 0
                        })
                } else {
                    aBO.ValidateMessageProvider.removeMessage('sourceid')
                }

                if (_.isEmpty(aBO.WB_GLTransaction.cif.POSTING_DATE)) {
                    aBO.ValidateMessageProvider.addMessage(
                        {
                            type: MessageType.Error,
                            code: 'txndate',
                            title: "Transaction Date cannot be empty",
                            description: "",
                            subtitle: "",
                            count: 0
                        })
                } else {
                    aBO.ValidateMessageProvider.removeMessage('txndate')
                }

                let bItemsInValid=false
                if (aBO.WB_GLTransaction.cif.TXN_TYPE=='accrual') {
                    bItemsInValid = _.filter(aBO.WB_GLTransaction.WB_GLTransactionItemRows, row => row.isActive && row.cif.TXN_AMOUNT > 0 && row.cif.WB_GLACCT_ID_EXP > 0 && row.cif.WB_GLACCT_ID_LIAB).length == 0
                }else{
                    bItemsInValid = _.filter(aBO.WB_GLTransaction.WB_GLTransactionItemRows, row => row.isActive && row.cif.TXN_AMOUNT > 0 && row.cif.WB_GLACCT_ID_LIAB).length == 0
                }
                if (bItemsInValid) {
                    aBO.ValidateMessageProvider.addMessage(
                        {
                            type: MessageType.Error,
                            code: 'txnnoitem',
                            title: "Transaction has no valid items (amount = 0 or GL Account is Empty)",
                            description: "",
                            subtitle: "",
                            count: 0
                        })
                } else {
                    aBO.ValidateMessageProvider.removeMessage('txnnoitem')
                }

                let arrTXN = await aBO.dbContext.findAll(esWB_GLTransaction,
                    {
                        where: {
                            DELETED_IND: {neq: '1'},
                            TXN_ID: aBO.WB_GLTransaction.cif.TXN_ID
                        }
                    })

                if (arrTXN.length) {
                    aBO.ValidateMessageProvider.addMessage(
                        {
                            type: MessageType.Error,
                            code: 'txnnotunique',
                            title: "Transaction ID is not unique",
                            description: "",
                            subtitle: "",
                            count: 0
                        })
                } else {
                    aBO.ValidateMessageProvider.removeMessage('txnnotunique')
                }


            } catch
                (err) {
                console.log("failed to retrieve Transaction Record to expand: " + err)
            }

        })();
    }
}